import { render, staticRenderFns } from "./SubCompany.vue?vue&type=template&id=6a779706&"
import script from "./SubCompany.vue?vue&type=script&lang=js&"
export * from "./SubCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports